import React, { useCallback, useEffect, useState } from 'react';
import { Layout } from './components/Layout';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { CareMatchingSection } from './components/CareMatchingSection';
import { HowItWorks } from './components/HowItWorks';
import { BiometricsSection } from './components/BiometricsSection';
import { PrivacySection } from './components/PrivacySection';
import { TherapistsSection } from './components/TherapistsSection';
import { FaqSection } from './components/FaqSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
import { WaitlistModal } from './components/WaitlistModal';
const PAGE_TITLE = 'Re:Joy — Therapist-led group care, in development';
const PAGE_DESCRIPTION = 'We’re building Re:Joy to bring you therapist-led group care that fits your needs, preferences, and everyday life. Join the waitlist for updates.';
export function App() {
  const [isWaitlistModalOpen, setIsWaitlistModalOpen] = useState(false);
  const openWaitlistModal = useCallback(() => setIsWaitlistModalOpen(true), []);
  const closeWaitlistModal = useCallback(() => setIsWaitlistModalOpen(false), []);
  useEffect(() => {
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = PAGE_DESCRIPTION;
  }, []);
  return <Layout data-id="element-0" data-mp="33n6yj5t6bx5w">
      <Navbar onOpenWaitlist={openWaitlistModal} data-id="element-1" data-mp="33myix65o2dr0" />
      <main id="main" data-id="element-2" data-mp="38li9jjv7gdpp">
        <Hero onOpenWaitlist={openWaitlistModal} data-id="element-3" data-mp="38l05i12awv78" />
        <CareMatchingSection data-id="element-4" data-mp="3dkuvm2e95gr8" />
        <HowItWorks data-id="element-5" data-mp="3dl4k1ljnffut" />
        <BiometricsSection data-id="element-6" data-mp="3dmfqxu8e53q5" />
        <PrivacySection data-id="element-7" data-mp="3dii4aymltu1i" />
        <TherapistsSection onOpenWaitlist={openWaitlistModal} data-id="element-8" data-mp="nvssd0714ftu" />
        <FaqSection data-id="element-9" data-mp="nxn4bp0boxls" />
        <CtaSection onOpenWaitlist={openWaitlistModal} data-id="element-10" data-mp="sunb624zy4dy" />
      </main>
      <Footer onOpenWaitlist={openWaitlistModal} data-id="element-11" data-mp="sssskuh76od1" />
      <WaitlistModal isOpen={isWaitlistModalOpen} onClose={closeWaitlistModal} data-id="element-12" data-mp="35ymodf6r9ya" />
    </Layout>;
}